module.exports = __webpack_public_path__ + "img/galeria-animales-1.2555ce72.jpg";